export const Button = ({
    children,
    onClick,
    variant = "primary",
    size = "md",
    className = ""
}) => {
    // Variants for button styles
    const baseStyles =
        "rounded-lg font-medium focus:outline-none transition-colors duration-200";

    const variants = {
        primary: "bg-primary-300 flex justify-center items-center",
        secondary: "border border-[#2c25c4] text-[#2c25c4] flex justify-center items-center",
        success: "bg-green-600 text-white hover:bg-green-700",
        danger: "bg-red-600 text-white hover:bg-red-700",
    };

    const sizes = {
        sm: "px-3 py-1 text-sm",
        md: "px-4 py-2 text-base",
        lg: "px-6 py-3 text-lg",
    };
    return (
        <button
            onClick={onClick}
            className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`}
        >
            {children}
        </button>
    );
};

